import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { SERVICES } from '@/data/content';
import { SectionHeading } from '@/components/site/SiteBits';
import { Seo } from '@/components/site/Seo';
import FinalCTA from '@/components/site/FinalCTA';

export default function Services() {
  return (
    <div data-testid="page-services">
      <Seo
        title="Home Repair & Handyman Services Fort Worth, TX | HearthOak"
        description="Drywall repair, interior & exterior painting, door installation, trim carpentry and small home repairs across Fort Worth, Burleson & DFW."
        path="/services"
      />
      <section className="border-b border-brand-border bg-brand-bone">
        <div className="container-x py-16 lg:py-24">
          <div className="max-w-3xl">
            <div className="eyebrow mb-3">Services</div>
            <h1 className="h1">Careful work across the parts of the home that matter most.</h1>
            <p className="body-lg mt-6">
              HearthOak Construction handles residential construction, repair, painting, doors, drywall, finish carpentry, flooring, and permanent lighting. The list below is what we do most. If your project is not listed, ask — a lot of what we do falls under "small construction and repair projects."
            </p>
            <p className="body-lg mt-4">
              Every service is owner-led and scoped in writing before work begins, for homeowners and property managers across Fort Worth, Burleson, Weatherford, Granbury, Cleburne, and the surrounding DFW area.
            </p>
          </div>
        </div>
      </section>

      <section className="surface-paper border-b border-brand-border">
        <div className="container-x py-16 lg:py-24">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {SERVICES.map((s) => {
              const Icon = Icons[s.icon] || Icons.Hammer;
              return (
                <Link
                  key={s.slug}
                  to={`/services/${s.slug}`}
                  className="group border border-brand-border bg-brand-bone hover:bg-brand-boneAlt transition-colors overflow-hidden"
                  data-testid={`services-list-${s.slug}`}
                >
                  {s.image && (
                    <div className="crop-frame w-full aspect-[16/9]">
                      <img
                        src={s.image}
                        alt={s.title}
                        loading="lazy"
                        className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                        data-testid={`services-img-${s.slug}`}
                      />
                    </div>
                  )}
                  <div className="p-8 lg:p-10">
                  <div className="flex items-start justify-between gap-6">
                    <div>
                      <Icon size={26} strokeWidth={1.5} className="text-brand-maroon" />
                      <h2 className="mt-5 font-serif text-2xl lg:text-3xl text-brand-charcoal">{s.title}</h2>
                      <p className="mt-3 font-sans text-sm text-brand-muted leading-relaxed">{s.short}</p>
                      <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-1 font-sans text-sm text-brand-charcoal">
                        {s.bullets.slice(0, 6).map((b) => (
                          <li key={b} className="flex items-start gap-2">
                            <Icons.Minus size={14} className="mt-1 text-brand-maroon" /> {b}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <Icons.ArrowUpRight className="text-brand-charcoal group-hover:text-brand-maroon transition-colors" size={22} />
                  </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
